export default "__VITE_ASSET__jR2WedqH__"